module.exports = __webpack_public_path__ + "img/bim5.e272153a.png";